var exports = {
  "x": "x936d19a0--462c85--button",
  "K": "x936d19a0--462c85--icon",
};

module.exports = exports;
